<template>
  <div class="form-card-container col-lg-5 p-0 mt-5 align-self-start">
    <div class="form-card-header bg-primary text-left py-1 px-3 text-white">{{title}}</div>
    <div class="from-card-body m-3">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class FormCard extends Vue {
  @Prop(String) title;
}
</script>